const Colours = {
  Amber:           '#FF9100',
  Black:           '#000',
  Blue:            '#0000ff',
  Crimson:         '#DC3545',
  ElectricBlue:    '#81F7FF',
  DarkTint:        '#333333aa',
  DarkGray:        '#7C7C7C',
  DefaultBkgrd:    '#fafafa',
  LighGrayBkgrd:   '#f8f8f8',
  LightGray:       '#EEEEEE',
  LightGray1:      '#F8F8F8',
  LightGray2:      '#D9D9D9',
  LightGray3:      '#ACAAAA',
  LightGray4:      '#F5F5F5',
  Link:            '#007bff',
  Gray:            '#555555',
  Gray1:           '#888888',
  Gray2:           '#A9A9A9',
  Gray3:           '#e9ecef',
  Gray4:           '#DBDBDB',
  Gray5:           '#C4C4C4',
  Gray6:           '#444444',
  Gray7:           '#F8F9FA',
  Green:           '#0F0',
  Green1:          '#34C759',
  MaterialBlue:    '#3f51b5',
  Orange:          '#ffa200',
  OrangePoiMarker: '#f15a24',
  Primary:         '#DE006F',
  Purple:          '#652483',
  Red:             '#F00',
  Red1:            '#e30b41',
  Secondary:       '#012EAA',
  Transaparent:    'transparent',
  White:           '#fff',
  Yellow:          '#9b870c',

};

export default Colours;
